import { ChevronRightIcon } from "@heroicons/react/24/outline";

export const Tertiary = (props) => {
  if (props.href) {
    return (
      <div>
        <a
          href={props.href}
          type="button" className="text-sm" style={{ cursor: "pointer" }}
        >
          <div className="flex">
            {props.text}
            <div className="grid content-center">
              <ChevronRightIcon className="h-3 w-3" />
            </div>
          </div>
        </a>
      </div>
    );
  }

  return (
    <div>
      {
        <button type="button" className="text-sm" style={{ cursor: "pointer" }}>
          <div className="flex">
            {props.text}
            <div className="grid content-center">
              <ChevronRightIcon className="h-3 w-3" />
            </div>
          </div>
        </button>
      }
    </div>
  );
};
